import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge must know the project's own @theme names (src/styles/index.css): without this `text-meta` (a font size)
 * is read as a text COLOUR and `cn("text-meta text-dim")` silently drops the size.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["label", "pill", "meta", "ui", "body-s", "body", "title", "h1"] }],
      "text-color": [{ text: ["surface", "panel", "panel-2", "line", "fg", "dim", "ok", "ok-ink", "danger-ink", "warn-ink", "ai-ink", "danger", "warn", "ai", "reserve", "own", "draft", "shade", "hl", "hl-ink", "gm"] }],
      "bg-color": [{ bg: ["surface", "panel", "panel-2", "line", "fg", "dim", "ok", "ok-ink", "danger-ink", "warn-ink", "ai-ink", "danger", "warn", "ai", "reserve", "own", "draft", "shade", "hl", "hl-ink", "gm"] }],
      "border-color": [{ border: ["surface", "panel", "panel-2", "line", "fg", "dim", "ok", "danger", "warn", "ai", "reserve", "own", "draft", "shade", "hl", "gm"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
